import { render, staticRenderFns } from "./InterfaceConfigurationForm.vue?vue&type=template&id=8b05748e&"
import script from "./InterfaceConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./InterfaceConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports